import { Box, BoxProps } from "@chakra-ui/react";
import { FiMaximize2 } from "react-icons/fi";

export const MaximizeIcon = (props: BoxProps) => {
  return <Box as={FiMaximize2} height="20px" width="20px" {...props} />;
};
